/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mcp_Server_Development_Remote_Title6Inputs */

const en_svc_mcp_server_development_remote_title6 = /** @type {(inputs: Svc_Mcp_Server_Development_Remote_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remote server, not localhost`)
};

const ar_svc_mcp_server_development_remote_title6 = /** @type {(inputs: Svc_Mcp_Server_Development_Remote_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خادم بعيد، لا محلي`)
};

const bn_svc_mcp_server_development_remote_title6 = /** @type {(inputs: Svc_Mcp_Server_Development_Remote_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রিমোট সার্ভার, লোকালহোস্ট নয়`)
};

const de_svc_mcp_server_development_remote_title6 = /** @type {(inputs: Svc_Mcp_Server_Development_Remote_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remote-Server, nicht Localhost`)
};

const es_svc_mcp_server_development_remote_title6 = /** @type {(inputs: Svc_Mcp_Server_Development_Remote_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Servidor remoto, no localhost`)
};

const fr_svc_mcp_server_development_remote_title6 = /** @type {(inputs: Svc_Mcp_Server_Development_Remote_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serveur distant, pas localhost`)
};

const pt_svc_mcp_server_development_remote_title6 = /** @type {(inputs: Svc_Mcp_Server_Development_Remote_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Servidor remoto, não localhost`)
};

const zh_svc_mcp_server_development_remote_title6 = /** @type {(inputs: Svc_Mcp_Server_Development_Remote_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`远程服务，不是本地`)
};

const tr_svc_mcp_server_development_remote_title6 = /** @type {(inputs: Svc_Mcp_Server_Development_Remote_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzak sunucu, localhost değil`)
};

const ru_svc_mcp_server_development_remote_title6 = /** @type {(inputs: Svc_Mcp_Server_Development_Remote_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалённый сервер, не localhost`)
};

const pl_svc_mcp_server_development_remote_title6 = /** @type {(inputs: Svc_Mcp_Server_Development_Remote_Title6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serwer zdalny, nie localhost`)
};

/**
* | output |
* | --- |
* | "Remote server, not localhost" |
*
* @param {Svc_Mcp_Server_Development_Remote_Title6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mcp_server_development_remote_title6 = /** @type {((inputs?: Svc_Mcp_Server_Development_Remote_Title6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mcp_Server_Development_Remote_Title6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mcp_server_development_remote_title6(inputs)
	if (locale === "bn") return bn_svc_mcp_server_development_remote_title6(inputs)
	if (locale === "de") return de_svc_mcp_server_development_remote_title6(inputs)
	if (locale === "es") return es_svc_mcp_server_development_remote_title6(inputs)
	if (locale === "fr") return fr_svc_mcp_server_development_remote_title6(inputs)
	if (locale === "pt") return pt_svc_mcp_server_development_remote_title6(inputs)
	if (locale === "zh") return zh_svc_mcp_server_development_remote_title6(inputs)
	if (locale === "tr") return tr_svc_mcp_server_development_remote_title6(inputs)
	if (locale === "ru") return ru_svc_mcp_server_development_remote_title6(inputs)
	if (locale === "pl") return pl_svc_mcp_server_development_remote_title6(inputs)
	return en_svc_mcp_server_development_remote_title6(inputs)
});
export { svc_mcp_server_development_remote_title6 as "svc_mcp-server-development_REMOTE_title" }